import '../../style/base.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/loading/style/index.js
// module id = 422
// module chunks = 0